import { EMPTY_LIST } from '../../../../constants/common'
import i18n from '../../../../i18n'
import { transformSelectAreaCoordinatesToPercentCoordinates } from '../../../PdfViewer'
import { DocFlowWidgetStatus } from '../../DocFlow.constants'
import { DocFlowMappingWidgetWithSelectedAreaNotificationType } from '../../DocFlow.hooks'
import { getDocFlowSelectedAreaAccuracyInitialValue } from '../../DocFlow.utils.mapping'
import { isDocFlowWidgetStatusSkipped } from '../../DocFlow.utils.widgets'
import { DocFlowMappingProcessCell } from '../../DocFlowMapping'
import { DocFlowSplittingType } from '../../DocFlowMappingWidgets'

import {
  DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_FOUND_ERROR_NOTIFICATION_ID,
  DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_FOUND_NOTIFICATION_ID,
  DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_NOT_CHANGED_ERROR_NOTIFICATION_ID,
  DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_NOTIFICATION_ID,
  DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_TEST_IN_PROCESS_NOTIFICATION_ID,
  DOC_FLOW_MAPPING_WIDGET_SPLITTING_NOTIFICATION_ID_SERVER_ERROR,
} from './DocFlowMappingWidgetSplitting.constants'

export function getWidgetSplittingTypeOptions() {
  return [
    {
      label: i18n.t('DocumentStapling.SplittingWidgetTypeAreaLabelKey'),
      value: DocFlowSplittingType.Area,
    },
  ]
}

export function getWidgetSplittingProcessPayload({
  isChanged,
  pdfPageCoordinates,
  previous,
  selectedBox,
  values,
}) {
  const payload = {}

  const type = values[DocFlowMappingProcessCell.SplittingType]?.value
  const isArea = isDocFlowSplittingTypeArea(type)
  const accuracy =
    values[DocFlowMappingProcessCell.SplittingMatchAccuracy]?.value
  const area = isArea
    ? transformSelectAreaCoordinatesToPercentCoordinates(
        selectedBox,
        pdfPageCoordinates
      )
    : null

  if (type) {
    payload[DocFlowMappingProcessCell.SplittingType] = type

    if (isArea) {
      payload[DocFlowMappingProcessCell.SplittingMatchAccuracy] = accuracy
      payload[DocFlowMappingProcessCell.SplittingArea] = area
    }

    if (!previous) {
      payload[DocFlowMappingProcessCell.SplittingPhase] =
        DocFlowWidgetStatus.Completed
      payload[DocFlowMappingProcessCell.MappingPhase] =
        DocFlowWidgetStatus.InProgress
    }
  } else if (!previous) {
    payload[DocFlowMappingProcessCell.SplittingPhase] =
      DocFlowWidgetStatus.Skipped
    payload[DocFlowMappingProcessCell.MappingPhase] =
      DocFlowWidgetStatus.InProgress
  }

  if (previous) {
    if (!type && isArea) {
      payload[DocFlowMappingProcessCell.SplittingMatchAccuracy] = accuracy
      payload[DocFlowMappingProcessCell.SplittingArea] = area
    }
  }

  if (!isChanged && payload[DocFlowMappingProcessCell.SplittingArea]) {
    delete payload[DocFlowMappingProcessCell.SplittingArea]
  }

  return payload
}

export function getWidgetSplittingInitialValueType(processData) {
  return !isDocFlowWidgetStatusSkipped(
    processData?.[DocFlowMappingProcessCell.SplittingPhase]
  ) && processData?.[DocFlowMappingProcessCell.SplittingType]
    ? getWidgetSplittingTypeOptions().find(
        option =>
          option.value ===
          processData?.[DocFlowMappingProcessCell.SplittingType]
      )
    : null
}

export function getWidgetSplittingInitialValues(processData, t) {
  return {
    [DocFlowMappingProcessCell.SplittingMatchAccuracy]:
      getDocFlowSelectedAreaAccuracyInitialValue(
        processData?.[DocFlowMappingProcessCell.SplittingMatchAccuracy],
        t
      ),
    [DocFlowMappingProcessCell.SplittingType]:
      getWidgetSplittingInitialValueType(processData),
  }
}

export function getWidgetSplittingSelectedAreaInfoData(data) {
  if (data.value) {
    return [
      {
        text: data.value,
        title: i18n.t('DocumentStapling.SplittingByTitleKey'),
      },
    ]
  }

  return EMPTY_LIST
}

export function getWidgetSplittingSelectedAreaPayload(value) {
  return {
    accuracy: value[DocFlowMappingProcessCell.SplittingMatchAccuracy].value,
  }
}

export function isSplittingAreaValue(values) {
  return (
    values[DocFlowMappingProcessCell.SplittingType]?.value ===
    DocFlowSplittingType.Area
  )
}

export function isDocFlowSplittingTypeArea(value) {
  return value === DocFlowSplittingType.Area
}

export function getWidgetSplittingNotifications(t) {
  return {
    [DocFlowMappingWidgetWithSelectedAreaNotificationType.AreaFound]: {
      id: DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_FOUND_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.SplittingSelectedAreaFoundNotificationTitleKey'
      ),
    },
    [DocFlowMappingWidgetWithSelectedAreaNotificationType.AreaNotFound]: {
      id: DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_FOUND_ERROR_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.SplittingSelectedAreaFoundErrorNotificationTitleKey'
      ),
    },
    [DocFlowMappingWidgetWithSelectedAreaNotificationType.NotChanged]: {
      id: DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_NOT_CHANGED_ERROR_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.SplittingSelectedAreaNotChangedNotificationTitleKey'
      ),
    },
    [DocFlowMappingWidgetWithSelectedAreaNotificationType.Phase]: {
      id: DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_NOTIFICATION_ID,
      text: t('DocumentStapling.SplittingWidgetAreaNotificationTitleKey'),
    },
    [DocFlowMappingWidgetWithSelectedAreaNotificationType.ServerError]: {
      id: DOC_FLOW_MAPPING_WIDGET_SPLITTING_NOTIFICATION_ID_SERVER_ERROR,
      text: t(
        'DocumentStapling.SplittingSelectedAreaServerErrorNotificationTitleKey'
      ),
    },
    [DocFlowMappingWidgetWithSelectedAreaNotificationType.TestInProcess]: {
      id: DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_TEST_IN_PROCESS_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.SplittingWidgetAreaTestInProcessNotificationTitleKey'
      ),
    },
  }
}
